import React, { useState } from "react";

const countries = [
  { value: "+1", label: "United States", code: "US", flagUrl: "https://flagcdn.com/us.svg" },
  { value: "+1", label: "Canada", code: "CA", flagUrl: "https://flagcdn.com/w40/ca.png" },
];

const FlagDropdown = ({ setCountryCode,hideFlag,countryCode }) => {
  const [selectedCountry, setSelectedCountry] = useState(countries[0]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleCountrySelect = (country) => {
    setSelectedCountry(country);
    setCountryCode(country.value);
    setIsDropdownOpen(false);
  };

  return (
    <>
    {hideFlag?<div className="absolute inline-block text-left w-24">
      <input
                type="text"
                id="phoneNumber"
                name="phoneNumber"
                className="border_color border text-sm rounded-lg block w-full p-2.5 h-12"
                required
                // placeholder="Your Phone Number"
                onChange={(e) =>{setCountryCode(e.target.value)}}
                value={countryCode}
              />
    </div>:<div className="absolute inline-block text-left w-24">
      <button
        className="flex items-center py-2 focus:outline-none field_bg border_color border text-base rounded-lg w-full p-2.5 h-12 bg-[#ffffff!important]"
        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
        aria-haspopup="true"
        aria-expanded={isDropdownOpen}
      >
        <img
          src={selectedCountry.flagUrl}
          alt={selectedCountry.label}
          className="w-6 h-4 mr-2"
        />
        <span className="text-sm font-medium">{selectedCountry.value}</span>
        <svg
          className={`ml-2 w-4 h-4 transition-transform ${isDropdownOpen ? "rotate-180" : "rotate-0"}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>
      {isDropdownOpen && (
        <ul
          className="mt-2 w-full bg-white rounded-md shadow-lg z-10 absolute"
          role="menu"
        >
          {countries.map((country) => (
            <li
              key={country.code}
              className="flex items-center px-3 py-2 cursor-pointer hover:bg-gray-100 "
              onClick={() => handleCountrySelect(country)}
              role="menuitem"
            >
              <img
                src={country.flagUrl}
                alt={country.label}
                className="w-6 h-4 mr-2"
              />
              <span className="text-sm font-medium">{country.value}</span>
            </li>
          ))}
        </ul>
      )}
    </div>}
    </>
  );
};

export default FlagDropdown;
